import { render, staticRenderFns } from "./unqualifiedModal.vue?vue&type=template&id=b4ddedb4&scoped=true"
import script from "./unqualifiedModal.vue?vue&type=script&lang=js"
export * from "./unqualifiedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ddedb4",
  null
  
)

export default component.exports